import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import * as styles from "./Footer.module.scss";
import config from "../../data/SiteConfig";
import Linkedin from "../svg/linkedin";
import Facebook from "../svg/facebook";
import Instagram from "../svg/instagram";
import FacebookAds from "../assets/facebookads.jpg";
import GoogleAds from "../assets/googleads.jpeg";
import _ from "lodash";

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(limit: 2000) {
        group(field: frontmatter___categories) {
          fieldValue
          totalCount
        }
      }
    }
  `);

  return (
    <footer>
      <div className={styles.container}>
        <div>
          <h3> اتصل بنا</h3>
          <a style={{ fontSize: 24 }} href='tel:05393394288'>
            905393394288 📞
          </a>

          <h3> روابط صفحات التواصل </h3>
          <a
            href={`https://www.facebook.com/rokkeycom`}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Facebook'
          >
            <Facebook />
          </a>
          <a
            href={`https://www.instagram.com/rokkeycom/`}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Instagram'
          >
            <Instagram />
          </a>
          <a
            href={`https://www.linkedin.com/company/14809747`}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='LinkedIn'
          >
            <Linkedin />
          </a>

          {/* <a
          href={config.siteUrl + config.siteRss}
          target="_blank"
          rel="noopener noreferrer"
        >
          RSS
        </a> */}
          <div style={{ marginTop: 20 }}>
            {" "}
            <a
              href={`https://www.rokkey.com/marketing-agency/`}
              style={{
                fontSize: 20,
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              هل تبحث عن زيادة المبيعات وتحقيق النجاح؟
            </a>
          </div>
          <div style={{ marginTop: 20 }}>
            {" "}
            <a
              href={`https://www.rokkey.com/membership-registration/`}
              style={{
                fontSize: 20,
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              هل تبحث عضوية التميز في منظمة هندسية دولية؟
            </a>
          </div>
        </div>

        <div>
          <h3>ضبط ومتابعة الحملات</h3>
          <p>
            <img width='140' height='76' src={FacebookAds} alt='FacebookAds' />
            <img width='140' height='76' src={GoogleAds} alt='GoogleAds' />
          </p>
          <h3> تصنيفات </h3>
          <ul className={styles.categoryFooter}>
            {data.allMarkdownRemark.group.map((category) => (
              <li key={category.fieldValue}>
                <Link
                  to={`/${_.kebabCase(category.fieldValue)}`}
                  key={category.fieldValue}
                  activeClassName={styles.activeNav}
                >
                  {category.fieldValue}
                  <strong> &nbsp; ({category.totalCount})</strong>
                </Link>
              </li>
            ))}
          </ul>
          <span className={styles.copyright}>{config.copyright}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
